export default class SupportTicket {

    constructor(subject, content, reporterEmail, origin) {
      this.subject = subject;
      this.content = content;
      this.reporterEmail = reporterEmail;
      this.origin = origin;
    }
}
  


// WEBPACK FOOTER //
// ./src/platform/support/vo/SupportTicket.js